import getAction from '../elements/getAction';
import getForm from '../elements/getForm';
import matchConditions from '../conditions/matchConditions';

export {
  getAction
};

/**
 * Runs conditional checks against the action, returning true if all given conditions are matched.
 *
 * @param {Element} action - The action step that contains the conditions to apply
 * @returns {boolean} True if all conditions were matched
 */
export function conditionsMet(action) {
  if(!action || !action.dataset.conditions) { return true; }
  const conditions = JSON.parse(action.dataset.conditions);
  const form = getForm(action);
  return matchConditions(form, conditions);
}
